import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { SvgIcon } from '@material-ui/core/'
import { mdiAccountCheck } from '@mdi/js'

import * as DoorAccessActionCreators from '../../actions/doorAccess'
import Pluralize from '../controls/Pluralize'
import TooltipIconButton from '../controls/TooltipIconButton'

class EnableUsersButtonContainer extends React.Component {
  static propTypes = {
    /* passed props */
    accessIds: PropTypes.array.isRequired,
    communityId: PropTypes.number.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
  }

  static mapStateToProps() {
    return {}
  }

  static mapDispatchToProps(dispatch) {
    return {
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  handleEnable = () => {
    this.props.doorAccessActions.enableDoorAccesses(this.props.communityId, this.props.accessIds)
  }

  render() {
    const userCount = this.props.accessIds.length
    const tooltipTitle = (
      <span>
        Enable <Pluralize count={userCount} showCount={userCount > 1} singular="User" />
      </span>
    )

    return (
      <TooltipIconButton
        color="primary"
        onClick={this.handleEnable}
        tooltipTitle={tooltipTitle}
      >
        <SvgIcon>
          <path d={mdiAccountCheck} />
        </SvgIcon>
      </TooltipIconButton>
    )
  }
}

export default connect(
  EnableUsersButtonContainer.mapStateToProps,
  EnableUsersButtonContainer.mapDispatchToProps,
)(EnableUsersButtonContainer)
